import { createRouter, createWebHistory } from 'vue-router'
import MenuView from '@/views/MenuView.vue'
import AdminLogin from '@/components/AdminLogin.vue'
import AdminPanel from '@/components/AdminPanel.vue'
import OrderManagement from '@/components/OrderManagement.vue'
import SectionTableManagement from '@/components/SectionTableManagement.vue'
import ReportsPage from '@/components/ReportsPage.vue'

const routes = [
  { path: '/', name: 'menu', component: MenuView },
  { path: '/admin/login', name: 'admin-login', component: AdminLogin },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPanel,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('authToken')
      if (!token) {
        next({ name: 'admin-login' })
      } else {
        next()
      }
    },
  },
  {
    path: '/admin/orders',
    name: 'admin-orders',
    component: OrderManagement,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('authToken')
      if (!token) {
        next({ name: 'admin-login' })
      } else {
        next()
      }
    },
  },
          {
          path: '/admin/sections-tables',
          name: 'admin-sections-tables',
          component: SectionTableManagement,
          beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('authToken')
            if (!token) {
              next({ name: 'admin-login' })
            } else {
              next()
            }
          },
        },
        {
          path: '/admin/reports',
          name: 'admin-reports',
          component: ReportsPage,
          beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('authToken')
            if (!token) {
              next({ name: 'admin-login' })
            } else {
              next()
            }
          },
        },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router


